module.exports = __webpack_public_path__ + "static/media/play.1d5f36a1.svg";